import { render, staticRenderFns } from "./NotificationRecipients.vue?vue&type=template&id=61093fd2&scoped=true"
import script from "./NotificationRecipients.vue?vue&type=script&lang=js"
export * from "./NotificationRecipients.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipients.vue?vue&type=style&index=0&id=61093fd2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61093fd2",
  null
  
)

export default component.exports